import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export interface IDonationIntent {
  targetType: 'boondock' | 'poi';
  targetId: number;
}

/** Resume half of the donation login-gate (see `redirectToSignIn()` in
 *  `auth-redirect.util.ts`) — call from a gated page's `ngOnInit` param
 *  subscription. Unlike `resumeFavoriteToggle`, a donation needs the guest to
 *  pick an amount, so this only parses + strips the `donateTarget`/`donateId`
 *  flags and hands the intent back for the caller to reopen the donate modal,
 *  rather than firing the donation itself. */
export function resumeDonationIntent(
  params: Record<string, string | undefined>,
  router: Router,
  route: ActivatedRoute,
  auth: AuthService,
): IDonationIntent | null {
  const targetType = params['donateTarget'] as 'boondock' | 'poi' | undefined;
  const rawId = params['donateId'];
  if (!targetType || !rawId || !auth.currentUser) return null;

  const targetId = Number(rawId);
  router.navigate([], {
    relativeTo: route,
    queryParams: { donateTarget: null, donateId: null },
    queryParamsHandling: 'merge',
    replaceUrl: true,
  });

  return Number.isFinite(targetId) ? { targetType, targetId } : null;
}
